import { adminSlice } from '@sonar-software/sonar-admin';
import { analyticWatchers } from './analytics/sagas';
import { applicationWatchers } from './application';
import { combineAllWatchers } from '@sonar-software/xuder';
import { coreSlice } from '@sonar-software/sonar-core';
import { importsSlice } from '@sonar-software/sonar-imports';
import { integrationsSlice } from '@sonar-software/sonar-integrations';
import { issuesSlice } from '@sonar-software/sonar-issues';
import { notificationsSlice } from '@sonar-software/sonar-notifications';
import { securitySlice } from '@sonar-software/sonar-security';

export const watchers = combineAllWatchers([
	analyticWatchers,
	applicationWatchers,
	adminSlice.adminWatchers,
	coreSlice.coreWatchers,
	importsSlice.importsWatchers,
	integrationsSlice.integrationWatchers,
	issuesSlice.issuesWatchers,
	notificationsSlice.watchNotificationsSagas,
	securitySlice.securityWatchers
]);
